import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Table } from 'onefaceui-react-components';

import { actionCreators } from 'react/api/actions/taskScheduler';
import { CustomProvider, renderComponent } from 'react/utils/renderUtils';
import { getResourceTo } from 'react/utils/utils';

import TaskSchedulerLogs from './TaskSchedulerLogs';
import TaskSchedulerActions from './TaskSchedulerActions';

function TaskSchedulerContent() {
  const dispath = useDispatch();
  const loadingSchedulers = useSelector((state) => state.taskScheduler.get('loadingSchedulers'));
  const errorIndex = useSelector((state) => state.taskScheduler.get('errorIndex'));
  const taskSchedulers = useSelector((state) => state.taskScheduler.get('taskSchedulers'));

  const closeAlert = (event) => {
    event.preventDefault();

    dispath(actionCreators.hideTaskSchedulerAlert());
  };

  const renderInfo = (message) => (
    <div id="taskSchedulerInfo">
      <div>{getResourceTo(message)}</div>
    </div>
  );

  const renderAlert = () => (
    <div id="taskSchedulerAlert" className={errorIndex ? 'showAlert' : ''}>
      <div id="closeAlert" onClick={closeAlert} aria-hidden="true" />
      <i className="fa fa-exclamation-circle" />
      {getResourceTo('TaskScheduler.requestError')}
    </div>
  );

  useEffect(() => {
    dispath(actionCreators.requestTaskSchedulers());
  }, []);

  const renderSchedulerContent = () => (
    <div id="taskSchedulerContent">
      {renderAlert()}
      <Flex>
        <Table
          columns={[
            {
              title: '',
              field: '',
              width: 70,
              headerSort: false,
              formatter: (cell, _, onRendered) => {
                const item = cell.getData();
                const index = cell.getRow().getPosition() - 1;

                onRendered(() => {
                  renderComponent(
                    <CustomProvider>
                      <TaskSchedulerActions item={item} index={index} />
                    </CustomProvider>,
                    cell.getElement()
                  );
                });
              },
              frozen: true
            },
            {
              title: Monet.I18n.getResourcesByKey('TaskScheduler.ruleType'),
              field: 'taskSchedulerRule',
              headerSort: false,
              formatter: (cell) => cell.getValue().type
            },
            {
              title: Monet.I18n.getResourcesByKey('TaskScheduler.organization'),
              field: 'organization',
              headerSort: false,
              formatter: (cell) => cell.getValue().description
            }
          ]}
          defaultData={taskSchedulers.toJS()}
          noDataMessage={getResourceTo('TaskScheduler.noData')}
          headerOptions={{
            showResults: false
          }}
          tableOptions={{
            rowHeight: 28
          }}
        />
        <TaskSchedulerLogs />
      </Flex>
    </div>
  );

  if (loadingSchedulers) {
    return renderInfo('TaskScheduler.loading');
  }

  return renderSchedulerContent();
}

export default TaskSchedulerContent;
